// Section gate (CEO 2026-10-21): a signed-in user who may not open this Hub
// section is sent to the one they can (lib/access.ts). The API refuses the
// data regardless; this keeps people out of screens full of 403s.
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { canSeeSection, homeFor, type HubSection } from "@/lib/access";

export function RequireSection({ section, children }: { section: HubSection; children: ReactNode }) {
  const { user } = useAuth();
  if (canSeeSection(user?.roles, section)) return <>{children}</>;
  const home = homeFor(user?.roles);
  if (home !== "/login") return <Navigate to={home} replace />;
  return (
    <div className="mx-auto max-w-xl p-8">
      <h1 className="text-[24px] font-semibold text-ink">No access</h1>
      <p className="mt-2 text-sm text-ink-muted">Your role doesn't include this part of the control centre. Ask an admin if you need it.</p>
    </div>
  );
}
